import { Component, OnInit, Input } from '@angular/core';
import { Course } from '../Models/course.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { MatDialog } from '@angular/material';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-courses-by-category',
  templateUrl: './courses-by-category.component.html',
  styleUrls: ['./courses-by-category.component.css']
})
export class CoursesByCategoryComponent implements OnInit {

  @Input()
  courses: Course[];

  @Input()
  category: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private cartItemsCookieService: CartItemsCookieService,
    private snotifyService: SnotifyService,
    public dialog: MatDialog,
    public domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  
  addItemToCart(course: Course){
    this.cartItemsCookieService.addItemIdToCartCookie(course.id);

    this.snotifyService.info(`Successfully added course: "${course.name}" to cart`, {position:SnotifyPosition.rightTop});

    this._router.navigateByUrl(`/cart-details`);
  }

  onShareClick(course: Course) {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
        width: '350px',
        data: { course: course }
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/courses-by-category/courses-by-category.component.ts